function diffStringsOrig(
  prev: string,
  cur: string,
  cursor: number
): [number, number, number] {
  const debug = (pos: number, added: number, removed: number) => {
    console.log(`${prev}->${cur}    ${pos} +${added} -${removed}`);
  };

  const commonLen = Math.min(prev.length, cur.length);
  let diffFirst = undefined;
  for (let i = 0; i < commonLen; i++) {
    if (prev[i] != cur[i]) {
      diffFirst = i;
      break;
    }
  }
  console.log(`${prev}->${cur} diffFirst ${diffFirst}`);
  let diffLast = undefined; // inclusive range
  for (
    let i = 0;
    i < commonLen - (diffFirst == undefined ? commonLen : diffFirst);
    i++
  ) {
    if (prev[prev.length - i - 1] != cur[cur.length - i - 1]) {
      diffLast = i;
      break;
    }
  }
  console.log(`${prev}->${cur} diffLast ${diffLast}`);

  let out: [number, number, number] | undefined = undefined;
  if (diffFirst != undefined && diffLast != undefined) {
    // const addCount = cursor - diffFirst;
    const removeCount = prev.length - diffLast - diffFirst;
    const addCount = cur.length - diffLast - diffFirst;

    out = [diffFirst, addCount, removeCount];
  } else if (diffFirst != undefined) {
    if (cur.length > prev.length) {
      const addCount = cur.length - prev.length;
      out = [diffFirst, addCount, 0];
    } else {
      const addCount = 1;
      const removeCount = prev.length - cur.length + 1;
      out = [diffFirst, addCount, removeCount];
    }
  } else if (diffLast != undefined) {
    if (cur.length > prev.length) {
      const addCount = cur.length - prev.length - diffLast;
      const pos = cursor - addCount;
      out = [pos, addCount, 0];
    } else {
      const removeCount = prev.length - cur.length - diffLast;
      const pos = cursor - removeCount;
      out = [pos, 0, removeCount];
    }
    // TODO
  } else if (diffFirst == undefined && diffLast == undefined) {
    if (cur.length > prev.length) {
      const addCount = cur.length - prev.length;
      const pos = cursor - addCount;
      out = [cursor - addCount, addCount, 0];
    } else {
      const pos = cursor;
      const removeCount = prev.length - cur.length;
      debug(pos, 0, removeCount);
      out = [pos, 0, removeCount];
    }
  }

  const [pos, addCount, removeCount] = out!;
  debug(pos, addCount, removeCount);
  if (prev.length + addCount - removeCount != cur.length) {
    throw Error("somethings does not add up");
  }
  if (!out) {
    throw Error("previously unseen use case");
  }

  return out;
}

function diffStringsNew(
  prev: string,
  cur: string,
  cursor: number
): [number, number, number] {
  const commonLen = Math.min(prev.length, cur.length);
  let diffFirst = undefined;
  for (let i = 0; i < Math.min(commonLen, cursor); i++) {
    if (prev[i] != cur[i]) {
      diffFirst = i;
      break;
    }
  }
  // console.log(`${prev}->${cur} diffFirst ${diffFirst}`);
  // let diffLast = undefined; // inclusive range
  // for (
  //   let i = 0;
  //   i < commonLen - (diffFirst == undefined ? commonLen : diffFirst);
  //   i++
  // ) {
  //   if (prev[prev.length - i - 1] != cur[cur.length - i - 1]) {
  //     diffLast = i;
  //     break;
  //   }
  // }
  // console.log(`${prev}->${cur} diffLast ${diffLast}`);

  let pos = undefined;
  let addCount = undefined;
  let removeCount = undefined;

  if (diffFirst != undefined) {
    pos = diffFirst;
  } else {
    pos = Math.min(commonLen, cursor - 1);
  }

  let commonTail = cur.length - cursor;

  // if (diffLast != undefined && diffLast > 0 && diffLast > commonTail) {
  //   commonTail = diffLast - 1;
  // }

  removeCount = prev.length - commonTail - pos;
  addCount = cur.length - commonTail - pos;

  // const debug = (pos: number, added: number, removed: number) => {
  //   console.log(`${prev}->${cur}    ${pos} +${added} -${removed}`);
  // };
  // debug(pos, addCount, removeCount);

  if (prev.length + addCount - removeCount != cur.length) {
    throw Error("somethings does not add up");
  }
  return [pos, addCount, removeCount];
}

export const diffStrings = diffStringsNew;
